import "./listing-hero.scss";

(function ($) {
  var mapMarkers = [];

  let map;

  function initMap($el) {
    var $markers = $el.find(".marker");
    var mapArgs = {
      zoom: $el.data("zoom") || 4,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: "8f3f6632debd3a28689323d0",
      // default to center of the US
      center: {
        lat: $el.data("lat") || 39.8283,
        lng: $el.data("lng") || -98.5795
      },

      disableDefaultUI: true,
      gestureHandling: "greedy"
    };
    map = new google.maps.Map($el[0], mapArgs);
    map.markers = [];

    map.setOptions({ minZoom: 3, maxZoom: 16 });

    // get current base url
    var base_url = window.location.origin;
    const icon_url = base_url + "/wp-content/uploads/2024/06/cluster-1.svg";

    const renderer = {
      render: ({ count, position }) =>
        new google.maps.Marker({
          label: {
            text: String(count),
            color: "white",
            fontSize: "14px",
            fontWeight: "bold"
          },
          position,
          icon: icon_url,

          // adjust zIndex to be above other markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
        })
    };

    $markers.each(function () {
      initMarker($(this), map);
    });

    centerMap(map);

    const options = {
      fields: ["formatted_address", "geometry", "name"],
      strictBounds: false
    };
    const input = document.getElementById("search-input");
    const autocomplete = new google.maps.places.Autocomplete(input, options);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        window.alert(
          "Please start typing and select an address from the suggestions."
        );
        return;
      }
      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        // aniamte to the location
        map.setCenter(place.geometry.location);
        map.setZoom(5);
      }
    });

    //

    return map;
  }

  function initMarker($marker, map) {
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    const genericMarker = document.createElement("img");
    genericMarker.width = 40;
    genericMarker.height = 40;
    genericMarker.src = "/wp-content/uploads/2024/06/pin.svg";

    const pinGlyph = new google.maps.marker.PinElement({
      glyph: "e",
      glyphColor: "white"
    });

    var marker = new google.maps.marker.AdvancedMarkerElement({
      position: latLng,
      map: map,
      content: genericMarker
    });
    // onclick event zoom and pan to marker
    marker.addListener("click", () => {
      map.setCenter(latLng);
      map.setZoom(18);
    });

    map.markers.push(marker);

    if ($marker.html()) {
      // var infowindow = new google.maps.InfoWindow({
      //   content: $marker.html()
      // });
      // google.maps.event.addListener(marker, "click", function () {
      //   infowindow.open(map, marker);
      // });
    }

    // mapMarkers.push(marker);
  }

  function centerMap(map) {
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      // bounds.extend({
      //   lat: marker.position.lat(),
      //   lng: marker.position.lng()
      // });
    });

    if (map.markers.length == 1) {
      // map.setCenter(bounds.getCenter());
    } else {
      // map.fitBounds(bounds);
    }
  }

  // Load the necessary Google Maps libraries
  function loadLibraries(callback) {
    google.maps.importLibrary("maps").then(() => {
      google.maps.importLibrary("marker").then(() => {
        callback();
      });
    });
  }

  $(document).ready(function () {
    $(".acf-map").each(function () {
      loadLibraries(() => {
        initMap($(this));
      });
    });
  });
})(jQuery);
